import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import BaseCircleLoader from "@/components-UI/BaseCircleLoader.vue";

interface Props {
    variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'link';
    size?: 'medium' | 'small' | 'extraSmall';
    contentVariant?: 'textOnly' | 'iconOnly' | 'withIcon';
    isDisabled?: boolean;
    isLoading?: boolean;
    isNotFillIcon?: boolean;
    isFullSize?: boolean;
    isTextCentered?: boolean;
    isNoWrapText?: boolean;
    isNoShadow?: boolean;
    text?: string;
    icon?: SVGElement
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButtonV2',
  props: {
    variant: { default: 'primary' },
    size: { default: 'medium' },
    contentVariant: { default: 'textOnly' },
    isDisabled: { type: Boolean },
    isLoading: { type: Boolean },
    isNotFillIcon: { type: Boolean },
    isFullSize: { type: Boolean },
    isTextCentered: { type: Boolean },
    isNoWrapText: { type: Boolean },
    isNoShadow: { type: Boolean },
    text: null,
    icon: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { variant: 'primary' | 'secondary' | 'outline' | 'ghost' | 'link', size: 'medium' | 'small' | 'extraSmall', contentVariant: 'textOnly' | 'iconOnly' | 'withIcon', isDisabled?: boolean, isLoading?: boolean, isNotFillIcon?: boolean, isFullSize?: boolean, isTextCentered?: boolean, isNoWrapText?: boolean, isNoShadow?: boolean, text?: string, icon?: SVGElement }





const getClasses = computed(() => {
    const classes = {
        [`--${props.variant}`]: props.variant,
        [`--${props.size}`]: props.size,
        [`--${props.contentVariant}`]: props.contentVariant,
        ['--not-fill-icon']: props.isNotFillIcon,
        ['--full-size']: props.isFullSize,
        ['--text-centered']: props.isTextCentered,
        ['--text-no-wrap']: props.isNoWrapText,
        ['--no-shadow']: props.isNoShadow,
    };
    return Object.keys(classes).filter((key) => classes[key]);
});

const isShowLoader = computed(() => props.isLoading && !props.isDisabled);


return { __sfc: true,props, emit, getClasses, isShowLoader, BaseCircleLoader }
}

})